import { Chip, CopyElement , proxyNumber } from "@ui";
import style from "./Operator.module.scss";
import { VodafoneSvg, LifecellSvg, KyivstarSvg } from "pages/user/MyProxiesPage/svg";
import { IProxy } from "@interfaces/user/proxy";
import { countries } from "../../../Table/components/TableRow/TableRow";
import { useChangeOperatorPurchaseMutation, useGetFreeOperatorsPurchaseQuery } from "@RTKQuery/user/purchases/purchases";
import { useAppSelector } from "store/hooks";
import { RiLoader5Fill } from "react-icons/ri";
import { extractError } from "UI/Button/Button";
import { useEffect } from "react";

export function Operator({
    data
}: {
    data: IProxy
}) {
    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage)

    const { data: freeOperators, isError, isFetching, error } = useGetFreeOperatorsPurchaseQuery({
        purchase_id: data.id
    })

    const [changeOperatorPurchase, changeOperatorPurchaseStatus] = useChangeOperatorPurchaseMutation();

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (changeOperatorPurchaseStatus.isSuccess || changeOperatorPurchaseStatus.isError) {
            timer = setTimeout(() => {
                changeOperatorPurchaseStatus.reset()
            }, 3000)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [changeOperatorPurchaseStatus]);

    return (
        <div className={style.container}>
            <div className={style.currentOperator}>
                <div className="flex gap-[10px] items-center">
                    <Icon operator={data.operator} />
                    <p className={style.name}>{data.operator}, {countries[data.tz]}</p>
                </div>
                <CopyElement
                    element={<p className={style.id}>№{proxyNumber(data)}</p>}
                    copyText={proxyNumber(data)}
                />
            </div>
            <div className={style.availableOperators}>
                <p className={style.label}>Доступні оператори:</p>
                <div className="flex gap-[20px] flex-wrap justify-center">
                    {
                        isFetching
                        ?  <RiLoader5Fill className={"animate-spin"} />
                        : null
                    }
                    {
                        isError
                        ? <p className={style.notFound}>
                            {
                                extractError(error) === "No free operators found"
                                ? "Вільних операторів не знайдено"
                                : "Непередбачувана помилка"
                            }
                        </p>
                        : null
                    }
                    {
                        freeOperators 
                        ? freeOperators.names.map((item, i) => (
                            <button
                                key={i}
                                onClick={() => {
                                    changeOperatorPurchase({
                                        purchase_id: data.id,
                                        params: {
                                            limit: activePaginationLimit,
                                            page: activePaginationPage,
                                            search: activeSearchParameter,
                                            tag_ids: activeTags
                                        },
                                        body: {
                                            proxy_router_id: freeOperators.proxy_router_id,
                                            operator: item,
                                            tariff_name: freeOperators.tariff
                                        }
                                    });
                                }}
                                className={style.operator}
                            >
                                <Icon operator={item} />
                                <p>{item}</p>
                                {
                                    changeOperatorPurchaseStatus.isError
                                        ? <div className={style.status}>
                                            <Chip
                                                text="Помилка"
                                                color="red"
                                            />
                                        </div>

                                        : null
                                }
                                {
                                    changeOperatorPurchaseStatus.isSuccess
                                        ? <div className={style.status}>
                                            <Chip
                                                text="Змінено"
                                                color="green"
                                            />
                                        </div>

                                        : null
                                }
                                {
                                    changeOperatorPurchaseStatus.isLoading
                                        ?
                                        <div className={style.status}>
                                            <RiLoader5Fill className={"animate-spin"} />
                                        </div>
                                        : null
                                }
                            </button>
                        ))
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

function Icon({ operator }: { operator: IProxy["operator"] }) {
    return (
        <>
            {
                operator.toLocaleLowerCase() === "vodafone"
                    ? <VodafoneSvg />
                    : operator.toLocaleLowerCase() === "lifecell"
                        ? <LifecellSvg />
                        : operator.toLocaleLowerCase() === "kyivstar"
                            ? <KyivstarSvg />
                            : null
            }
        </>
    )
}